export const header = [
    {name: 'Home', route: 'https://avisilease.co.za/'},
    {name: 'View Sample Offers', route: '/sample-offers'},
]